import React, { useContext, useState, useEffect } from 'react';
import Layout from '../../../components/Layout/user/Layout';
import useGlobalContext, { GlobalContext } from '../../../context/provider';
import './styles.scss';
import {
  IonGrid,
  IonRow,
  IonCol,
  IonItem,
  IonLabel,
  IonInput,
  IonButton,
  IonText,
  IonIcon,
  IonSpinner,
} from '@ionic/react';
import { DeviceContext } from '../../../deviceType';
import { pencil } from 'ionicons/icons';
import { updateUser } from '../../../context/actions/user';
import ErrorToast from '../../../components/error_toast';
import { UPDATE_USER_ERROR } from '../../../context/actions/types';
import { User } from '../../../types/user';

const Profile = () => {
  const device = useContext(DeviceContext);

  const { userDispatch } = useGlobalContext();
  const { userState } = useContext<any>(GlobalContext);
  const [userDetails, setUserDetails] = useState({} as User);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isToastOpen, setIsToastOpen] = useState<boolean>(false);
  const [toastMessage, setToastMessage] = useState<{
    type: 'error' | 'warning' | 'success';
    message: string;
  }>({
    type: 'success',
    message: '',
  });

  useEffect(() => {
    const getUser = async () => {
      const user = await userState.getUser;
      setUserDetails(user);
    };
    getUser();
  }, [userState.getUser]);

  // Validate the form whenever the profile state changes
  useEffect(() => {
    const isValid =
      userDetails?.firstName?.trim() !== '' &&
      userDetails?.lastName?.trim() !== '' &&
      userDetails?.email?.trim() !== '' &&
      userDetails?.phoneNumber?.trim() !== '';
    setIsFormValid(isValid);
  }, [userDetails]);

  const toggleEditMode = () => setIsEditing(!isEditing);

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setUserDetails({ ...userDetails, [name]: value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    const dataToUpload: any = {
      firstName: userDetails?.firstName,
      lastName: userDetails?.lastName,
    };
      if(userDetails?.phoneNumber?.trim().length) {
        dataToUpload.phoneNumber = userDetails?.phoneNumber;
      }

    await updateUser({ id: userDetails?.id, data: dataToUpload })(userDispatch);

    setLoading(false);
    setIsEditing(false);
  };

  useEffect(() => {
    if (userState.updateUser) {
      setUserDetails(userState.updateUser);
      setToastMessage({
        type: 'success',
        message: 'Your details have been updated successfully.',
      });
      setLoading(false);

      setIsToastOpen(true);
      setIsEditing(false);
    }
    if (userState.updateUserError) {
      setUserDetails(userState.getUser);
      setToastMessage({
        type: 'error',
        message: userState.updateUserError!?.response!?.data!?.message
          ? userState.updateUserError!?.response!?.data!?.message
          : userState.updateUserError!?.message,
      });
      setLoading(false);

      setIsEditing(false);
      setIsToastOpen(true);
      userDispatch({ type: UPDATE_USER_ERROR, payload: null });
    }
  }, [userState, userDispatch]);

  return (
    <Layout>
      <ErrorToast
        message={toastMessage?.message}
        type={toastMessage?.type}
        isOpen={isToastOpen}
        onClose={() => {
          setIsToastOpen(false);
        }}
      />

      <div
        className={
          'wrapper w-full  md:w-1/2 md:mx-auto px-4 bg-white py-5 mt-[120px]'
        }
      >
        <h2 className="w-full text-lg mt-2 md:mt-4 text-center font-semibold">Profile Details</h2>

        <form onSubmit={handleSubmit} className="">
          <div>
            <IonItem>
              <IonLabel position="floating">First name</IonLabel>
              <IonInput
                name="firstName"
                value={userDetails?.firstName}
                onIonChange={handleInputChange}
                required
              />
            </IonItem>
            <IonItem>
              <IonLabel position="floating">Last name</IonLabel>
              <IonInput
                name="lastName"
                value={userDetails?.lastName}
                onIonChange={handleInputChange}
                required
              />
            </IonItem>
            <IonItem>
              <IonLabel position="floating">Phone Number</IonLabel>
              <IonInput
                name="phoneNumber"
                type="tel"
                value={userDetails?.phoneNumber}
                onIonChange={handleInputChange}
              />
            </IonItem>
            <IonItem>
              <IonLabel position="floating">Email</IonLabel>
              <IonInput
                name="email"
                type="email"
                value={userDetails?.email}
                readonly={true}
                disabled={true}
              />
            </IonItem>
          </div>
          <div className="w-full flex justify-center items-center mt-8">
            <IonButton type="submit" disabled={!isFormValid}>
              Update profile
              {loading && <IonSpinner slot="end"></IonSpinner>}
            </IonButton>
          </div>
        </form>
      </div>
    </Layout>
  );
};

export default Profile;
